import React, { useCallback, } from 'react';
import { useDispatch } from 'react-redux';
import { Col, List, Row, Tooltip } from 'antd';

import LearningCenterPlayButton from './LearningCenterPlayButton';

import { createNuxEntry, deleteNuxEntry } from '../nux/state/nux.actions';
import { TUTORIAL_WATCH_PREFIX } from '../nux/nux.constants';
import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';

export default ({
  tutorials,
  header,
}) => {
  const dispatch = useDispatch();

  const changeWatched = useCallback((item) => (checked) => {
    item.watched = checked;
    if (checked) {
      dispatch(createNuxEntry(`${TUTORIAL_WATCH_PREFIX}${item.key}`));
    } else {
      dispatch(deleteNuxEntry(`${TUTORIAL_WATCH_PREFIX}${item.key}`));
    }

  });

  return (
    <div>
      <div className='learning-center-list'>
        <List
          header={header}
          dataSource={tutorials}
          itemLayout='vertical'
          locale={{emptyText: 'No Matching Search Results'}}
          style={{ paddingLeft: 5 }}
          renderItem={(item) =>
            <List.Item
              key={item.title}
              extra={
                <div style={{ height:'100%' }}>
                  <Row>
                    <Col>
                      <LearningCenterPlayButton tutorial={item.key}/>
                    </Col>
                  </Row>
                </div>
              }
            >
              <List.Item.Meta
                title={(
                  <Tooltip placement="left" title={item.watched ? 'Watched' : 'Unwatched'}>
                    <OnTraccrCheckbox
                      value={item.watched}
                      onChange={changeWatched(item)}
                      label={item.title}
                    />
                  </Tooltip>
                )}
                description={<div><b>Audience:</b> {item.audience ? item.audience.toString() : ''}</div>}
              />
              <div>{item.description}</div>
            </List.Item>
          }
        />
      </div>
    </div>
  );
}